<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_iii"></a><strong>Rebooting the American Dream</strong></h1>
<p class="subtitle"><strong>11 Ways to Rebuild Our Country</strong></p>
<p class="author">Thom Hartmann</p>
<p class="image"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?b92ae052